import { FC, useEffect, useRef } from 'react';
import { _js } from '@ifixit/localize';
import { InstantSearch as InstantSearchComponent } from '@ifixit/ui/components/instant-search';
import { KeyboardNavigation } from 'Shared/keyboard_navigation';
import { getIndexes, getSearchClient, ORDERED_DOCTYPES, PUBLIC_KEY } from 'Guide/searchClient';

interface InstantSearchBarProps {
   isOnCart?: boolean;
   isMobile?: boolean;
}

/**
 * InstantSearchBar component that provides search functionality in the header
 * with keyboard shortcut support
 */
const InstantSearchBar: FC<InstantSearchBarProps> = ({ isOnCart = false }) => {
   // Determine the appropriate placeholder text based on context
   const placeholder = isOnCart ? _js('Search by device or model #') : _js('Search');

   const searchClient = getSearchClient();
   const indices = getIndexes();
   const keyboardNavigationRef = useRef<typeof KeyboardNavigation | null>(null);

   useEffect(() => {
      // Set up keyboard shortcut to focus the search input
      const focusSearchInput = () => {
         const searchInput = document.querySelector('.instant-search-input') as HTMLInputElement;
         if (searchInput) searchInput.focus();
      };

      if (!keyboardNavigationRef.current) {
         // Initialize KeyboardNavigation only once
         keyboardNavigationRef.current = new KeyboardNavigation({
            keys: { '/': focusSearchInput },
         });
      }
   }, []);

   return (
      <InstantSearchComponent
         searchClient={searchClient}
         apiKey={PUBLIC_KEY}
         indices={indices}
         orderedDoctypes={ORDERED_DOCTYPES}
         indexFilters={App.algoliaConfig.filtersByObjectType}
         placeholder={placeholder}
         currency={App.userPreferredStoreCurrency}
         localeCode={App.userPreferredStoreLocale}
         storeCode={App.userPreferredStoreCode}
         className="flex-grow"
         shortcutKey="/"
         inputProps={{
            className: 'rounded-full',
         }}
         popoverProps={{
            sideOffset: 20,
         }}
      />
   );
};

export default InstantSearchBar;
